import * as Yup from 'yup';

export default Yup.object().shape({
  team: Yup.string().required(),
});
